import { CSSProperties, useState } from "react";
import { DAlternativeScreen, DAlternativeScreenHolder } from "./DAlternativeScreen";
import { DCol } from "./DCol";
import { DText } from "./DText";
import { DUploadButton } from "./DAvatarWithChangePicture";
import { DWebTS } from "../common_ts/DWebTS";
import { TObject } from "corexxx";
import { DRadioButton } from "./DRadioButton";
import { DTextJSON } from "./DTextJSON";
import { DTable } from "./DTable";
import { DRow } from "./DRow";
import { DSpace } from "./DSpace";
import { DRefreshButton } from "./DRefreshButton";
import { DButton } from "./DButton";
import { Button } from "@mui/material";
import { DTextError } from "./DTextError";

export function DImport({ style, onProgress }: { style?: CSSProperties, onProgress: (obj: TObject[]) => void }) {
    const [page, setPage] = useState("import")
    const [view, setView] = useState("text")
    const [raw_text, set_rawText] = useState('')
    const [obj, setObj] = useState<TObject[]>([]);
    const [error, setError] = useState('');
    return <DCol>
        <DAlternativeScreenHolder
            style={{ background: 'white', padding: 30, borderRadius: 5 }}
            activescreen={page}>
            <DAlternativeScreen name="import">
                <DCol style={{ alignItems: 'center' }}>
                    <DText>Please click the upload button to upload a csv files</DText>
                    <DUploadButton
                        fileType="*/*"
                        style={{ marginTop: 30 }}
                        buttonType="normal"
                        onChange={async function (obj?: any, e?: any) {
                            try {

                                let data = await DWebTS.readCSVFile(e)
                                set_rawText(data)
                                setPage("preview_text")
                                setObj(DWebTS.csvToArray(data))
                            } catch (e: any) {
                                setError(e.message)
                            }
                        }} />
                    <DTextError error={error} />
                </DCol>
            </DAlternativeScreen>
            <DAlternativeScreen name="preview_text">
                <DCol>
                    <DRow center>
                        <Button variant="text" onClick={() => setPage('import')}>↩</Button>
                        <DText>Verify and Update</DText>
                        <DSpace />
                        <DRadioButton value={view} onChange={setView} options={[{ value: 'text' }, { value: 'json' }, { value: 'table' }]} />
                    </DRow>
                    {view == "json" ? <DTextJSON obj={obj} /> : null}
                    {view == "table" ? <DTable data={obj} columns={obj.length == 0 ? [] : Object.keys(obj[0]).map(x => ({ field: x }))} /> : null}
                    <DRow style={{ marginTop: 10 }}><DSpace /><DButton onClick={async () => {
                        try {
                            await onProgress?.(obj);
                        } catch (e: any) {
                            setError(e.message)
                        }
                    }}>Next</DButton></DRow>
                    <DTextError error={error} />
                </DCol>
            </DAlternativeScreen>
        </DAlternativeScreenHolder>
    </DCol>
}